export const VARIANT = process.env.REACT_APP_BUILD_VARIANT || "standard";

export const GF_URL = "https://guardianfamily.it";
export const VIP_URL = "https://vip.guardianfamily.it";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.guardian2.family";

// Sul dominio VIP le rotte dell'app sono relative; dal sito standard il
// collegamento verso VIP è puramente informativo (solo home).
// Accedi / dashboard login: same-origin /login su entrambi i build.
// Standard NON deve mandare a vip.guardianfamily.it/login (fix marketing Accedi 2026-09-24).
export const VIP_LOGIN_URL =
  VARIANT === "vip" ? "/login" : "/login";
export const VIP_REGISTER_URL =
  VARIANT === "vip" ? "/register" : "https://vip.guardianfamily.it/register";
// VIP acquista: Stripe 59,99 €/mese · APK post-pagamento (non Google Play)
export const VIP_ACQUISTA_URL =
  VARIANT === "vip" ? "/acquista" : "https://vip.guardianfamily.it/acquista";
export const VIP_DOWNLOAD_URL =
  VARIANT === "vip" ? "/download" : "https://vip.guardianfamily.it/download";

export const PRIVACY_URL =
  VARIANT === "vip" ? "/privacy" : "https://guardianfamily.it/privacy";
export const NOTE_LEGALI_URL =
  VARIANT === "vip" ? "/note-legali" : "https://guardianfamily.it/note-legali";
export const CONDIZIONI_PRO_URL =
  VARIANT === "vip" ? "/condizioni-pro" : "https://vip.guardianfamily.it/condizioni-pro";
